<div class="list-parent-cmp">
  <app-request-menu class="menu-cmp"></app-request-menu>
  <app-request-filter class="filter-cmp"></app-request-filter>
  <div class="flex-container">
    <app-list-message class="message-cmp flex-message"></app-list-message>
    <app-header-in-batch></app-header-in-batch>
  </div>
  <div class="lists-cmp">
    <app-request-map-list [ngStyle]="getStyleMap()"
                            class="map-list"
                            *ngIf="showMap | async">
    </app-request-map-list>
    <app-request-summary-list [ngStyle]="getStyleList()"
                                class="sum-list"
                                *ngIf="showList | async">
    </app-request-summary-list>
  </div>
</div>
